"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNetworkBlockTimeByNetworkNetworkEnum = exports.InfoApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class InfoApi extends runtime.BaseAPI {
    /**
     * Get Core API information
     * Get Core API info
     */
    async getCoreApiInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CoreNodeInfoResponseFromJSON(jsonValue));
    }
    /**
     * Get Core API information
     * Get Core API info
     */
    async getCoreApiInfo(initOverrides) {
        const response = await this.getCoreApiInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get a given network\'s target block time
     */
    async getNetworkBlockTimeByNetworkRaw(requestParameters, initOverrides) {
        if (requestParameters.network === null || requestParameters.network === undefined) {
            throw new runtime.RequiredError('network', 'Required parameter requestParameters.network was null or undefined when calling getNetworkBlockTimeByNetwork.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/info/network_block_time/{network}`.replace(`{${"network"}}`, encodeURIComponent(String(requestParameters.network))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.NetworkBlockTimeResponseFromJSON(jsonValue));
    }
    /**
     * Get a given network\'s target block time
     */
    async getNetworkBlockTimeByNetwork(requestParameters, initOverrides) {
        const response = await this.getNetworkBlockTimeByNetworkRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the network target block time
     */
    async getNetworkBlockTimesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/info/network_block_times`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.NetworkBlockTimesResponseFromJSON(jsonValue));
    }
    /**
     * Get the network target block time
     */
    async getNetworkBlockTimes(initOverrides) {
        const response = await this.getNetworkBlockTimesRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get Proof of Transfer (PoX) information. Can be used for Stacking.
     * Get PoX details
     */
    async getPoxInfoRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/v2/pox`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.CoreNodePoxResponseFromJSON(jsonValue));
    }
    /**
     * Get Proof of Transfer (PoX) information. Can be used for Stacking.
     * Get PoX details
     */
    async getPoxInfo(initOverrides) {
        const response = await this.getPoxInfoRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get Blockchain API status
     * Get Blockchain API status
     */
    async getStatusRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ServerStatusResponseFromJSON(jsonValue));
    }
    /**
     * Get Blockchain API status
     * Get Blockchain API status
     */
    async getStatus(initOverrides) {
        const response = await this.getStatusRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get total and unlocked STX supply
     */
    async getStxSupplyRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetStxSupplyResponseFromJSON(jsonValue));
    }
    /**
     * Get total and unlocked STX supply
     */
    async getStxSupply(requestParameters, initOverrides) {
        const response = await this.getStxSupplyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get circulating STX supply in plain text format
     */
    async getStxSupplyCirculatingPlainRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply/circulating/plain`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     * Get circulating STX supply in plain text format
     */
    async getStxSupplyCirculatingPlain(initOverrides) {
        const response = await this.getStxSupplyCirculatingPlainRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get total STX supply in plain text format
     */
    async getStxSupplyTotalSupplyPlainRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply/total/plain`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.TextApiResponse(response);
    }
    /**
     * Get total STX supply in plain text format
     */
    async getStxSupplyTotalSupplyPlain(initOverrides) {
        const response = await this.getStxSupplyTotalSupplyPlainRaw(initOverrides);
        return await response.value();
    }
    /**
     * Get total and unlocked STX supply (results formatted the same as the legacy 1.0 API)
     */
    async getTotalStxSupplyLegacyFormatRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/stx_supply/legacy_format`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GetStxSupplyLegacyFormatResponseFromJSON(jsonValue));
    }
    /**
     * Get total and unlocked STX supply (results formatted the same as the legacy 1.0 API)
     */
    async getTotalStxSupplyLegacyFormat(requestParameters, initOverrides) {
        const response = await this.getTotalStxSupplyLegacyFormatRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.InfoApi = InfoApi;
/**
    * @export
    * @enum {string}
    */
var GetNetworkBlockTimeByNetworkNetworkEnum;
(function (GetNetworkBlockTimeByNetworkNetworkEnum) {
    GetNetworkBlockTimeByNetworkNetworkEnum["testnet"] = "testnet";
    GetNetworkBlockTimeByNetworkNetworkEnum["mainnet"] = "mainnet";
})(GetNetworkBlockTimeByNetworkNetworkEnum = exports.GetNetworkBlockTimeByNetworkNetworkEnum || (exports.GetNetworkBlockTimeByNetworkNetworkEnum = {}));
//# sourceMappingURL=InfoApi.js.map